import * as React from "react";
const SvgArrowDownS = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "m12 16-6-6h12z" })));
export default SvgArrowDownS;
//# sourceMappingURL=ArrowDownS.js.map